import {
  GegenstandCategory,
  SpartenType,
  TaasGegeData,
  TaasTarifrisikoschluesselGEGE,
  VorschadenArt,
  VorschadenTaaS
} from '@ps20/bff-models';
import { parseDatum } from '@ps20-frontend/preis-lib';
import { DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';
import dayjs from 'dayjs';
import { IAppState } from '../../appState';

export function buildTaasGegeDataForStrecke(state: IAppState): TaasGegeData {
  const gegeData: TaasGegeData = generateBasicTaasGegeData(state);
  state.produkt.produktlinien.forEach(produktLinie => {
    gegeData.salesProducts[produktLinie.produktName.toUpperCase()] = [
      {
        schluessel: TaasTarifrisikoschluesselGEGE.GEGE,
        ausgewaehlt: true,
        isGefahr: true,
        isInklusiv: false,
      },
    ];
  });
  return gegeData;
}

export function buildTaasGegeDataForShop(state: IAppState): TaasGegeData {
  const gegeData: TaasGegeData = generateBasicTaasGegeData(state);
  state.produkt.produktlinien
    .filter(produktLinie => produktLinie.selected)
    .forEach(produktLinie => {
      gegeData.salesProducts[produktLinie.produktName.toUpperCase()] = [
        {
          schluessel: TaasTarifrisikoschluesselGEGE.GEGE,
          ausgewaehlt: true,
          isGefahr: true,
          isInklusiv: false,
        },
      ];
    });
  return gegeData;
}

function hasFahrradGegenstand(state: IAppState): boolean {
  return state.gegenstandsschutz.items.some(item => item.category?.id === GegenstandCategory.FAHRRAD);
}

function generateBasicTaasGegeData(state: IAppState): TaasGegeData {
  return {
    spartenType: SpartenType.GEGENSTANDSSCHUTZ,
    plzVN: state.versicherungsnehmer.adresse.plz,
    geburtsdatumVN: parseDatum(state.versicherungsnehmer.geburtsdatum),
    salesProducts: {},
    gegenstaende: state.gegenstandsschutz.items.map(item => {
      return {
        id: item.id,
        insuranceValue: item.insuranceValue,
        categoryId: item.category.id,
        purchaseDate: dayjs(item.purchaseDate).format(DATEFORMAT_SHORT_ISO),
        selfParticipation: state.vertragsoptionen.selbstbeteiligung,
      };
    }),
    vorschaden: hasFahrradGegenstand(state)
      ? [
          {
            vorschadenArt: VorschadenArt.RAD,
            anzahl: state.fahrradVorschaeden.count,
            manuallyEntered: state.fahrradVorschaeden.manuallyEntered,
          } as VorschadenTaaS,
        ]
      : null
  };
}
